export let hrms62eColumns = () => {
  let indexColumns = [
    {
      key: 'codempid_query',
      name: '',
      labelCodapp: 'HRMS62EC1',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 120px;'
    }, {
      key: 'desc_codempid_query',
      name: '',
      labelCodapp: 'HRMS62EC1',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRMS62EC1',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'seqno',
      name: '',
      labelCodapp: 'HRMS62EC1',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 80px;'
    }, {
      key: 'numlereq',
      name: '',
      labelCodapp: 'HRMS62EC1',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 120px;'
    }, {
    //   key: 'desc_codleave',
    //   name: '',
    //   labelCodapp: 'HRMS62EC1',
    //   labelIndex: '80',
    //   style: 'min-width: 150px;'
    // }, {
      key: 'dtetimperiod',
      name: '',
      labelCodapp: 'HRMS62EC1',
      labelIndex: '80',
      style: 'min-width: 400px;',
      headerRow: 1,
      colspan: 4,
      rowspan: 1
    }, {
      key: 'dtestrt',
      name: '',
      labelCodapp: 'HRMS62EC2',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 100px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1,
      dataType: 'date'
    }, {
      key: 'dteend',
      name: '',
      labelCodapp: 'HRMS62EC2',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 100px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1,
      dataType: 'date'
    }, {
      key: 'timstrt',
      name: '',
      labelCodapp: 'HRMS62EC2',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 100px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'timend',
      name: '',
      labelCodapp: 'HRMS62EC2',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 100px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRMS62EC1',
      labelIndex: '90',
      style: 'min-width: 200px;'
    }, {
      key: 'remarkap',
      name: '',
      labelCodapp: 'HRMS62EC1',
      labelIndex: '100',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'HRMS62EC1',
      labelIndex: '110',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRMS62EC1',
      labelIndex: '140',
      style: 'min-width: 200px;'
    }
  ]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}

export let hrms62eMaxRowspan = {
  index: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms62e.js